export default "__VITE_ASSET__DboU_iIP__";